import React, { useState } from 'react'

import useFirebase from 'hooks/firebase'

import { useUtils } from 'config/utils'

import {
  Alert,
  Button,
  Collapse,
  Container,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material'

import CloseIcon from '@mui/icons-material/Close'

const LandingWhen = (props) => {

  const { validateEmail } = useUtils()

  const { firestore } = useFirebase()
  const { addDocToCollection } = firestore

  const [open, setOpen] = useState(false)

  const [email, setEmail] = useState('')
  const handleEmailChanged = (event) => {
    setEmail(event.target.value)
  }

  const [firstName, setFirstName] = useState('')
  const handleFirstNameChanged = (event) => {
    setFirstName(event.target.value)
  }

  const [fathersLastName, setFathersLastName] = useState('')
  const handleFathersLastNameChanged = (event) => {
    setFathersLastName(event.target.value)
  }
  
  const [mothersLastName, setMothersLastName] = useState('')
  const handleMothersLastNameChanged = (event) => {
    setMothersLastName(event.target.value)
  }

  const [comments, setComments] = useState('')
  const handleCommentsChanged = (event) => {
    setComments(event.target.value)
  }

  const onSendComments = async () => {
    clear()
    const data = {
      email,
      firstName,
      fathersLastName,
      mothersLastName,
      comments,
    }

    await addDocToCollection('contact', data)
    setOpen(true)
  }

  const clear = () => {
    setFirstName('')
    setFathersLastName('')
    setMothersLastName('')
    setEmail('')
    setComments('')
  }

  return (
    <Container maxWidth='sm'>
      <Grid container spacing={2} p={4} py={8}>
        <Grid item xs={12}>
          <Typography align='center' color='primary' variant='h3' gutterBottom>
            <b style={{ fontWeight: 900 }}>¿Cuando hablámos?</b>
          </Typography>
          <Typography align='center' color='#00c08b' variant='h5' gutterBottom>
            <b style={{ fontWeight: 700 }}>Ponte en contacto</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                value={firstName}
                onChange={handleFirstNameChanged}
                placeholder='Ingresa tu(s) nombre(s)'
                label='Nombre(s)'
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{ flexGrow: 1 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                value={fathersLastName}
                onChange={handleFathersLastNameChanged}
                placeholder='Ingresa tu apellido paterno'
                label='Apellido paterno'
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{ flexGrow: 1 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                value={mothersLastName}
                onChange={handleMothersLastNameChanged}
                placeholder='Ingresa tu apellido materno'
                label='Apellido materno'
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{ flexGrow: 1 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={email}
                onChange={handleEmailChanged}
                placeholder='Ingresa el email'
                label='Email'
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{ flexGrow: 1 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={comments}
                onChange={handleCommentsChanged}
                placeholder='Ingresa tus comentarios'
                label='Comentarios'
                InputLabelProps={{ shrink: true }}
                fullWidth
                multiline
                rows={4}
                sx={{ flexGrow: 1 }}
              />
            </Grid>
            <Grid item xs={12}>
              <Collapse in={open}>
                <Alert 
                  severity='success' 
                  action={
                    <IconButton color='inherit' onClick={() => setOpen(false)}>
                      <CloseIcon fontSize='inherit' />
                    </IconButton>
                  }
                >
                  Hemos recibido tu mensaje, nos pondremos en contacto contigo lo más pronto posible.
                </Alert>
              </Collapse>
            </Grid>
            <Grid item xs={12} align='center'>
              <Button disabled={ firstName === '' || fathersLastName === '' || mothersLastName === '' || !validateEmail(email) || comments === '' } fullWidth color='lightGreen' disableElevation variant='contained' onClick={onSendComments} size='large' sx={{ mr: 'auto' }}>
                <b style={{ fontWeight: 900 }}>ENVIAR</b>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}

export default LandingWhen